import 'components/TestimonialsSection.css';
import { useTranslation } from 'react-i18next';

import ReviewCard from 'components/ReviewCard';
import image1 from 'res/sushi-review1.avif';
import image2 from 'res/sushi-review2.avif';
import image3 from 'res/sushi-review3.avif';
import FeedbackForm from './FeedbackForm';

const TestimonialsSection = () => {
    const { t } = useTranslation();

    return (
        <div className="testimonials-section">
            <h1>{t('testimonials-header')}</h1>
            <div className="review-cards-container">
                <ReviewCard className="hidden-mobile" image={image1} text={t('review1')} author={t('author')} />
                <ReviewCard image={image2} text={t('review2')} author={t('author')} />
                <ReviewCard className="hidden-mobile" image={image3} text={t('review3')} author={t('author')} />
                <FeedbackForm className="feedback-form-grid" />
            </div>
        </div>
    )
};

export default TestimonialsSection;